
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"9","cy":"9","r":"8"}}),_c('path',{attrs:{"d":"M11.515 6.484l-5.03 5.031m5.03 0l-5.03-5.03M9 17","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    